import { render } from "./CreateLogBookPlaceholderUser.vue?vue&type=template&id=6b8d05a1"
import script from "./CreateLogBookPlaceholderUser.vue?vue&type=script&lang=js"
export * from "./CreateLogBookPlaceholderUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__